import type { MouseEvent } from "react"
import type Lenis from "lenis"

declare global {
  interface Window {
    __lenis?: Lenis
  }
}

const NAV_OFFSET = -72

export function scrollToSection(hrefOrId: string) {
  const id = hrefOrId.replace(/^#/, "")
  const element = document.getElementById(id)
  if (!element) return

  const lenis = window.__lenis
  if (lenis) {
    lenis.scrollTo(element, { offset: NAV_OFFSET, duration: 1.2 })
    return
  }

  element.scrollIntoView({ behavior: "smooth", block: "start" })
}

export function handleSectionLinkClick(
  event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  hrefOrId: string,
) {
  if (!hrefOrId.startsWith("#")) return

  event.preventDefault()
  scrollToSection(hrefOrId)
}
